import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { useTranslation } from 'react-i18next';

export default function FinishCarpentryOrderDialog(props) {

    const classes = useStyles();
    const { t } = useTranslation();

    return (

        <Dialog className={classes.dialogContainer} open={props.dialogOpen}>
            <DialogTitle className={classes.dialogTitle}>
                {props.dialogTitle}
            </DialogTitle>
            <DialogActions>
                <div className={classes.buttons}>
                    <Button className={classes.cancelButton} onClick={() => props.closeDialog()}>
                        {t("CANCEL")}
                    </Button>
                    <Button className={classes.submitButton} onClick={() => props.action()} >
                        {t("OK")}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
}

const useStyles = makeStyles(() => ({

    dialogContainer: {
        width: "620px !important",
        margin: "auto"
    },
    buttons: {
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        width: "235px",
    },
    submitButton: {
        color: "white",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: FlagstoneTheme.palette.primary.main,
        margin: "3px",
        width: "110px",
        marginTop: "20px",
        marginBottom: "20px"
    },
    cancelButton: {
        color: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "#E6E8FE",
        '&:hover': {
            backgroundColor: "#E6E8FE",
        },
        margin: "3px",
        width: "110px",
        marginBottom: "30px",
        marginTop: "20px",
        float: "left"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "20px",
        paddingBottom: "0px",
    }
}));
